import GovCoHeader from '@/components/blocks/PageHeaderBar/public/GovCoHeader';
import LogosHeader from '@/components/blocks/PageHeaderOrganizationBar/public/LogosHeader';

import MobileHeader from '../../../blocks/PageHeaderOrganizationBar/public/MobileHeader';
import NavigationBar from '../../../blocks/PageNavigationBar/public/NavigationBar';
import WrapperGrayScale from '../../Accessibility/WrapperGrayScale';
import { useLayoutContext } from '../LayoutProvider/LayoutContext';

const Header = () => {
  const { layout } = useLayoutContext();
  const { isNavigationLoading } = layout;

  return (
    <>
      {/* === MOBILE/TABLET (< lg): GovCo + Logos fijos === */}
      <div className="sticky left-0 right-0 top-0 z-sticky md:hidden">
        <MobileHeader />
      </div>

      <div className="fixed left-0 right-0 top-0 z-sticky hidden md:block lg:hidden">
        <GovCoHeader />
        <WrapperGrayScale>
          <LogosHeader />
        </WrapperGrayScale>
      </div>

      {/* Spacer mobile */}
      <div className="hidden h-[142px] md:block lg:hidden" />

      {/* === DESKTOP (>= lg) === */}
      {/* GovCo fijo siempre */}
      <div className="fixed left-0 right-0 top-0 z-sticky hidden lg:block">
        <GovCoHeader />
      </div>

      {/* Spacer para GovCo fijo */}
      <div className="hidden h-[44px] lg:block" />

      {/* Logos - se desplazan con el contenido */}
      <div className="relative z-dropdown hidden lg:block">
        <WrapperGrayScale>
          <LogosHeader />
        </WrapperGrayScale>
      </div>

      {/* NavigationBar sticky - se queda fijo debajo de GovCo al hacer scroll */}
      <div className="sticky top-[44px] z-base hidden lg:block">
        <NavigationBar isLoading={isNavigationLoading} />
      </div>
    </>
  );
};

/* type TAlertProps = {
  className?: string
} */

export const AlertHeader = () => {
  return null;
  /*return (
    <div className={cx(styles.alert, className)}>
      <div className={styles.exclamation}>
        <SvgExclamation className='text-black' />
      </div>
      <div className={styles.alertInfo}>
        <div className={styles.text}>
          Texto de notificación de alerta o información sumamente importante
          para el ciudadano
        </div>
        <div className={"text-link text-black md:mt-0 mt-2"}>
          {"Recordármelo luego"}
        </div>
      </div>
    </div>
  );*/
};

export default Header;
